import styled from 'styled-components';

import bp from '../breakpoints';

export const Wrapper = styled.div`
  display: none;

  @media screen and (max-width: ${bp.tablet}) {
    display: block;
  }
`;

export const Text = styled.div`
  margin-left: 8px;
`;
